<template>
    <v-app :style="allSettingsVariables" class="main-menu-app">
    <notify-wrapper/>
    <!-- APPLICATION BAR  -->
    <v-app-bar
      :style="{'box-shadow':'0 0 20px rgba(0, 0, 0, 0.13)', 'left':'0', 'height':'var(--top-toolbar-height)'}"
      id="home-app-bar"
      flat
      app
      v-if="!isAppInIFrame"
    >
      <div class="main-logo-wrapper">
      <template v-if="isUserAuthenticated">
        <v-btn v-if="!menuState.isOpenMenu && !menuState.isSecondClickToFix" icon @click="openMenu()" small>
          <v-icon>mdi mdi-menu</v-icon>
        </v-btn>
        <v-btn v-else :class="{ 'fixed': isFixMenu && menuState.isSecondClickToFix }" icon @click="openFixMenu()">
          <v-icon class="pin" :display="isFixMenu && menuState.isSecondClickToFix ? 'flex' : 'none'">mdi mdi-pin</v-icon>
        </v-btn>
      </template>
      
      <div class="menu-layout-logo" @click="openFunctionMenu()">
        <svg class="full-logo" :style="`height:var(--top-toolbar-logo-image-height); width:var(--top-toolbar-logo-image-width);fill:rgb(${settingsVariables['--md-pallete-rgb-on-500']})`">
          <use :xlink:href="require('@it-enterprise/web-app-common/src/assets/rmd-icons.svg') + `#ICON_IT-LOGO`"></use>
        </svg>
      </div>
      </div>
      <div class="close-menu-function-field" @click="closeFunctionMenu" v-if="menuState.isOpenMenu || haveFunctionMenu"></div>
      <v-spacer class="app-main-menu-spacer"/>
      <div class="lang-switcher-container">
        <lang-switcher/>
      </div>
      <div v-if="$notificationsCore.notificationsIsEnabled" class="notifications-container">
        <notifications color="white"/>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-if="!isUserAuthenticated" @click="goToLogin()" v-bind="attrs" v-on="on">
            <v-icon class="pa-2">mdi mdi-login</v-icon>
          </v-btn>
        </template>
        <span>{{$t('menuLayout.login')}}</span>
      </v-tooltip>
      <div v-if="isUserAuthenticated" @click="showUserPanel=!showUserPanel">
        <v-img class="toolbar-user-photo" v-if="!needDefaultImage && $store.state.auth.user.authData" :src="$store.state.auth.user.authData.userPhoto" @load="load() " @error="error()"/>
        <v-icon class="toolbar-user-photo icon" v-else>mdi-account-circle</v-icon>
      </div>

      <div class="user-account-panel" v-if="showUserPanel">
        <div class="uap-top">
          <div v-if="!needDefaultImage" class="uap-photo circular-photo">
            <v-img :src="$store.state.auth.user.authData.userPhoto"/>
          </div>
          <div class="uap-top-info">
            <div>
              <div class="uap-user-fio">{{$store.state.auth.user.authData.userName}}</div>
              <div class="uap-user-login">{{$store.state.auth.user.authData.login}}</div>
              <div class="uap-action uap-user-change-pass" @click="openChangePasswordDialog">{{$t('menuLayout.changePassword')}}</div>
            </div>
            <div class="uap-serv-buttons">
              <div class="uap-action" @click="openLayoutSettingsDialog" :title="$t('menuLayout.openLayoutSettings')">
                <dr-svg image="SOFT" color="#737373" size="24"></dr-svg>
              </div>
            </div>
          </div>
          <div class="uap-user-actions">
            <div v-for="action in userActions" :class="{ 'uap-user-actions-button': true, 'uap-user-actions-button-dd': (action.items || []).length > 0 }" v-bind:key="action.key">
              <div class="uap-u-a-caption">
                <div class="uap-u-a-title">{{ userActionsDescription[action.key].Text }}</div>
                <v-select
                  v-model="userActionsDescription[action.key].ActiveItem"
                  :items="userActionsDescription[action.key].Items"
                  class="uap-action"
                  item-text="text"
                  item-value="tag"
                  item-color="unset"
                  hide-details
                  @change="onItemClick($event, action.key)"
                >
                  <template v-slot:selection="{ item }">
                    <div class="selection-text">{{ item.text }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div class="text-content">{{ item.text }}</div>
                  </template>
                  <template v-if="action.key == 'ChangeGroup'" v-slot:append-item>
                    <v-divider/>
                    <v-list-item v-for="item in userActionsDescription[action.key].ServiceItems" 
                      v-bind:key="item.key"
                      link
                      @click="onItemClick(item.tag, action.key)">
                      <div class="text-content">{{ item.text }}</div>
                    </v-list-item>
                  </template>
                  <template v-else v-slot:append-item>
                    <v-divider/>
                    <v-list-item v-for="item in userActionsDescription[action.key].ServiceItems" 
                      v-bind:key="item.key"
                      link
                      :class="{ 'active': item.isActive }"
                      @click="onItemClick(item.tag, action.key, item.key)">
                      <div class="text-content">{{ item.text }}</div>
                    </v-list-item>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-app-bar>
    <div v-else style="display:none">
      <lang-switcher ref="langSwitcher"/>
    </div>
    <div class="main-launcher-container" :class="{ 'hidden-menu' : isHiddenMenu }" v-if="menuState.isOpenMenu">
      <dr-launcher-component :items="itemsMenu" :isLoading="isLoading" :favoriteModule="favoriteModule" :favoriteItems="listView" :baseUrl="baseUrl" @changedCode="changedCode" @removeFromFavorite="removeFromFavorite" @addToFavorite="addToFavorite"  @setSignFunctionMenu="setSignFunctionMenu" @setMenuVisibility="setMenuVisibility"></dr-launcher-component>
    </div>
    <!-- CONTENT -->
    <v-main  :style="`background: ${this.$route.name.toLowerCase() == 'homepageanon' ? this.$vuetify.theme.themes.light.accent : 'white'} `">
      <v-progress-linear
      v-if="loader"
      indeterminate
      height="5"
      color="primary"
      absolute
    ></v-progress-linear>
      <dr-layout-placeholder v-if="this.$route.name.toLowerCase() == 'homepageanon'" style="height: 100%;" :model="{$ID:'pl3'+this.routeName, Name:'Main'}">
      </dr-layout-placeholder>
      <div :class="{ 'content-container': true, 'inFrame': isAppInIFrame && settingsMode }" v-else>
        <div class="main-launcher-container-fix-mode" v-if="isFixMenu">
          <dr-launcher-component class="" :isFixMenu="isFixMenu" :items="itemsMenu" v-if="isFixMenu" :isLoading="isLoading" :favoriteModule="favoriteModule" :isAppInIFrame="isAppInIFrame" :baseUrl="baseUrl" :favoriteItems="listView" @removeFromFavorite="removeFromFavorite" @addToFavorite="addToFavorite" @changedCode="changedCode" @setSignFunctionMenu="setSignFunctionMenu" ref="launcher"></dr-launcher-component>
        </div>
        <dr-layout-main-component ref="layout" v-if="layoutDescription" :settingsMode="settingsMode" :items="layoutDescription" :historyProps="historyProps" :listView="listView" :selectMenuItem="selectMenuItem" @updateLayout="updateLayoutFromDashboard" @changedCode="changedCode" :isAppInIFrame="isAppInIFrame" :baseUrl="baseUrl" @removeFromFavorite="removeFromFavorite"></dr-layout-main-component> 
        <dr-settings-layout-component v-if="settingsMode" ref="layoutSettings" :mainLayout="layoutDescription" :historyProps="historyProps" @updatePanels="onUpdatePanels" @undoHistory="undoHistory" @redoHistory="redoHistory"></dr-settings-layout-component>
      </div>
    </v-main>
    <change-password-dialog v-model="showChangePasswordDialog" v-if="showChangePasswordDialog" @closeDialog="closeDialog"/>
  </v-app>
</template>
<script>

import { MainMenuApi as api } from '../api/api.js'
import LangSwitcher from '@/components/LangSwitcher'
import NotifyWrapper from '@/components/NotifyWrapper'
import mainMenuMixin from '@/mainMenuSrc/mixins/mainMenuMixin'
import '@/mainMenuSrc/styles/mainMenu.css'
import UserSettings from '@/mainMenuSrc/api/userSettings'
import Notifications from '@/components/Notifications'
import drSvg from '@/mainMenuSrc/components/customWidgets/dr-svg'

const listClassesOutsidEelements = [
  'list-view-container',
  'top-bar',
  'lvc-main',
  'uap-user-change-pass',
  'main-logo-wrapper',
  'app-main-menu-spacer',
  'list-view-item-normal'
]

export default {
  name: 'MenuLayout',
  props: [ 'settingsMode' ],
  mixins: [mainMenuMixin],
  components: {
    LangSwitcher,
    NotifyWrapper,
    changePasswordDialog: () => import('../components/dialogs/changePasswordDialog.vue'),
    drLauncherComponent: () => import('../components/customWidgets/dr-launcher-component.vue'),
    'dr-layout-main-component': () => import('../components/customWidgets/dr-layout-main-component.vue'),
    drSvg,
    'dr-settings-layout-component': () => import('../components/customWidgets/dr-settings-layout-component.vue'),
    Notifications
  },
  data: () => ({
    needDefaultImage: false,
    favoriteModule: [],
    haveFunctionMenu: false,
    menuState: {
      isOpenMenu: false,
      isSecondClickToFix: false // упростить логику фиксации меню
    },
    isFixMenu: false,
    showChangePasswordDialog: false,
    showUserPanel: false,
    historyProps: {
      undoDisable: true,
      redoDisable: true,
      stopWriteHistory: false
    },
    settingsVariables: [],
    isHiddenMenu: false,
    userActions: [],
    userActionsDescription: {
      ChangeGroup: {
        Text: '',
        ActiveItem: {},
        Items: [],
        ServiceItems: []
      },
      ChangeObj: {
        Text: '',
        ActiveItem: {},
        Items: [],
        ServiceItems: []
      }
    }
  }),
  computed: {
    allSettingsVariables() {
      return this.getUserSettingsVariables()
    },
    menuStateIsFixMenu: {
      get() {
        return this.isFixMenu
      },
      set(value) {
        this.isFixMenu = value
        api.mainMenuUnFixState(true, !value)
        this.$refs.layout.onChanged()
      }
    }
  },
  methods: {
    outsideClick(event) {
      if (!this.showUserPanel) {
        return
      }

      for (let i = 0; i < listClassesOutsidEelements.length; i++) {
        let outsideElement = window.document.getElementsByClassName(listClassesOutsidEelements[i])[0]
        if (!outsideElement) {
          continue
        }
        if (outsideElement.contains(event.target)) {
          this.showUserPanel = false
        }
      }
    },
    openChangePasswordDialog() {
      this.showChangePasswordDialog = true
    },
    openMenu() {
      this.menuState.isOpenMenu = true
      this.setMenuVisibility(true)
    },
    // Зафексировать меню
    openFixMenu() {
      if (this.menuState.isSecondClickToFix) {
        this.menuStateIsFixMenu = this.menuState.isOpenMenu = this.menuState.isSecondClickToFix = false
        return
      }
      this.menuStateIsFixMenu = !this.menuStateIsFixMenu
      this.menuState.isSecondClickToFix = true
      this.menuState.isOpenMenu = false
    },
    // Переход на страницу логина
    goToLogin() {
      this.$routerCore.GoToSignIn()
    },
    // Открытие меню с функциями
    openFunctionMenu() {
      if (!this.isUserAuthenticated) {
        this.$routerCore.GoToSignIn()
        return
      }
    },
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    },
    closeFunctionMenu() {
      this.haveFunctionMenu = false
      if (this.menuStateIsFixMenu) {
        // TODO: Заменить на EvantBus
        this.$refs.launcher.closeChildrenMenu()
        return
      }
      this.menuState.isOpenMenu = false
    },
    setSignFunctionMenu(value) {
      this.haveFunctionMenu = value
      this.setMenuVisibility(value)
    },
    // Добавление в избранное
    addToFavorite(item) {
      let newItem = {...item}
      for (let row = 0; row < 10; row++) {
        let items = this.listView.filter( x => x.position?.normal?.row === row.toString())
        if (!items.length) {
          newItem.position = {
            normal: {
              column: '0',
              row: row.toString()
            }
          }
          this.listView.push(newItem)
          this.refreshStorage('listView', this.listView)
          return
        }
        if (items.length === 9) {
          continue
        }

        let columnIndexs = items.map(x => x.position.normal.column)
        let index = this.getFreeColumnIndex(columnIndexs)
        newItem.position = {
          normal: {
            column: index.toString(),
            row: row.toString()
          }
        }
        this.listView.push(newItem)
        this.refreshStorage('listView', this.listView)
        return
      }
    },
    // Получить свободную колонку
    getFreeColumnIndex(array) {
      if (!array.length) {
        return 0
      }

      let arrayIndex = array.map(x => +x)
      let index = Math.max(...arrayIndex)
      ++index
      return index
    },
    // Удаление из избранного
    removeFromFavorite(codeMenu) {
      this.listView = this.listView.filter( x => x.codeMenu !== codeMenu)
      for (let i = 0; i < this.favoriteModule.length; i++) {
        this.favoriteModule[i].children = this.favoriteModule[i].children.filter( x => x.codeMenu !== codeMenu)
      }
      let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      data.data.iTEnterpriseMenuQuery.menu.moduleContent.children = this.favoriteModule
      data.data.iTEnterpriseMenuQuery.listView.items = this.listView
      localStorage.setItem('appMainMenuCacheMenu', JSON.stringify(data))
    },
    // Переименование элемента
    renameListViewItem({codeMenu, caption}) {
      let item = this.listView.find( x => x.codeMenu === codeMenu) 
      if (item) {
        item.name = caption
      }
      this.refreshStorage('listView', this.listView)
    },
    refreshStorage(key, value) {
      let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      data.data.iTEnterpriseMenuQuery[key].items = value
      localStorage.setItem('appMainMenuCacheMenu', JSON.stringify(data))
    },
    closeDialog() {
      this.showChangePasswordDialog = false
    },
    openLayoutSettingsDialog() {
      this.$routerCore.router.push({ name: 'LayoutSettings' })
    },
    onUpdatePanels(selected) {
      this.$refs.layout.updatePanels(selected)
    },
    updateLayoutFromDashboard(newItems) {
      this.layoutDescription = newItems
    },
    undoHistory() {
      this.$refs.layout.undoHistory()
    },
    redoHistory() {
      this.$refs.layout.redoHistory()
    },
    getUserSettingsVariables() {
      this.settingsVariables = UserSettings.GetAllSettingsVariable(this.userSettings)
      return this.settingsVariables
    },
    setMenuVisibility(visible) {
      this.isHiddenMenu = !visible
    },
    async onItemClick(value, action, key) {
      if (action == 'ChangeGroup') {
        await api.doRmdUserAction('5', value)
        window.location.reload()
      } else if (action == 'ChangeObj') {
        if (!key) {
          await api.doRmdUserAction('3', value, this.userActionsDescription.ChangeObj.ServiceItems[0].isActive, this.userActionsDescription.ChangeObj.ServiceItems[1].isActive)
          window.location.reload()
        } else {
          let serviceItem = this.userActionsDescription.ChangeObj.ServiceItems.find(item => item.key == key)
          serviceItem.isActive = !serviceItem.isActive
        }
      }
    }
  },
  beforeDestroy() {
    window.document.body.removeEventListener('click', this.outsideClick)
  },
  async created() {
    window.document.body.addEventListener('click', this.outsideClick)
    let data = await api.mainMenuUnFixState()
    this.menuState.isSecondClickToFix = this.isFixMenu = !data.data.iTEnterpriseMenuQuery.mainMenuUnFixState
    if (this.userActions.length == 0) {
      let data = await api.getUserActions()
      this.userActions = data.data.iTEnterpriseMenuQuery.getUserActions.items
      for (let i = 0; i < this.userActions.length; i++) {
        if (this.userActions[i].items.length && this.userActionsDescription[this.userActions[i].key]) {
          let description = this.userActionsDescription[this.userActions[i].key]
          if (this.userActions[i].key == 'ChangeObj') {
            description.Text = this.$t('menuLayout.object')
            description.Items = this.userActions[i].items.filter(item => item.key != 'SERVICEITEMS')
            description.ServiceItems = this.userActions[i].items.find(item => item.key == 'SERVICEITEMS').items
          }
          if (this.userActions[i].key == 'ChangeGroup') {
            description.Text = this.$t('menuLayout.settingsLayout.group')
            description.Items = this.userActions[i].items.filter(item => item.tag !== '0')
            description.ServiceItems = [this.userActions[i].items.findLast(item => item.tag === '0')]
          }
          description.ActiveItem = this.userActions[i].items.find(item => item.isActive).tag
        }
      }
    }
  },
  mounted() {
    if (this.$refs.langSwitcher) {
      if (this.settingsMode && this.isAppInIFrame) {
        let query = location.search.indexOf('?') >= 0 ? location.search.substring(location.search.indexOf('?') + 1) : location.search
        let parts = query.split('&')
        if (parts.length == 0 || (parts.length == 1 && !parts[0])) {
          return
        }
        let langParam = parts.find(e => e.includes('lang'))
        if (langParam) {
          let lang = langParam.substr(langParam.indexOf('=') + 1).toLowerCase()
          if (this.$refs.langSwitcher.lang.code != lang && this.$refs.langSwitcher.locales.find(l => l.code == lang)) {
            this.$refs.langSwitcher.lang = lang
          }
        }
      } else {
        let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
        let projectCode = data.data.iTEnterpriseMenuQuery.menu.currentProject
        let lang = projectCode.substr(projectCode.length - 2)
        if (this.$refs.langSwitcher.lang.code != lang && this.$refs.langSwitcher.locales.find(l => l.code == lang)) {
          this.$refs.langSwitcher.lang = lang
        }
      }
    }
  }
}
</script>
<style scoped>

.menu-layout-logo {
  display: flex;
  align-items: center;
  cursor: pointer
}

.main-menu-app .v-dialog--fullscreen {
  height: calc(100% - var(--top-toolbar-height)) !important;
  margin-top: var(--top-toolbar-height) !important;
}
.main-launcher-container-fix-mode {
  margin: 0px !important;
  display: flex;
}
.main-launcher-container {
  position: fixed;
  z-index: 1000;
  background-color: white;
  transition: 1s;
  width: 100%;
  bottom: 0px;
}
.main-menu-app .v-btn--icon.v-size--default .v-icon.pin {
  transform: rotate(45deg);
  padding: 4px;
  font-size: 19px;
  width: 20px;
  height: 20px;
}

.main-menu-app .close-menu-function-field {
  background-color: rgba(rgb(55, 0, 255), rgb(128, 0, 70), rgb(62, 153, 77), .5);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 70px;
  z-index: 111111;
}

.main-menu-app .v-app-bar {
  background-color: var(--md-pallete-500) !important;
  color: var(--md-pallete-on-500) !important;
}

.main-menu-app .v-app-bar .v-list-item__content, .main-menu-app .v-app-bar::v-deep .v-btn, .main-menu-app .v-app-bar .v-list-item__content .v-list-item__subtitle, 
  .main-menu-app .v-app-bar .menu-layout-logo .full-logo{
  color: var(--md-pallete-on-500) !important;
  fill: var(--md-pallete-on-500);
}

.main-menu-app .v-app-bar::v-deep .v-toolbar__content {
  height: var(--top-toolbar-height) !important;
  padding: 0px;
}
.main-logo-wrapper {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  width: var(--top-toolbar-full-logo-width);
  margin-left: 10px;
}
.v-app-bar .main-logo-wrapper::v-deep .v-btn, .v-toolbar__content .main-logo-wrapper::v-deep .v-btn.v-btn--icon.v-size--default, .v-toolbar__extension .main-logo-wrapper::v-deep .v-btn.v-btn--icon.v-size--default {
  height: var(--top-toolbar-height);
  width: 28px;
  margin-right: 10px;
  background: unset;
}
.main-logo-wrapper::v-deep .v-btn:focus:before,
.main-logo-wrapper::v-deep .v-btn:hover:before,
.main-logo-wrapper::v-deep .v-btn .v-ripple__container,
.lang-switcher-container::v-deep .v-btn:focus:before,
.lang-switcher-container::v-deep .v-btn:hover:before,
.notifications-container::v-deep .v-btn:focus:before,
.notifications-container::v-deep .v-btn:hover:before  {
  opacity: 0;
}

.main-logo-wrapper .v-btn .v-icon {
  transition: unset;
}
.main-logo-wrapper::v-deep .v-btn:hover span, .main-logo-wrapper::v-deep .v-btn.fixed span {
  background: rgba(255, 255, 255, 0.4);
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 4px;
  box-sizing: unset;
  margin: 0px;
}

.main-menu-app .v-app-bar .v-avatar.v-list-item__avatar {
  height: var(--top-toolbar-height) !important;
  min-width: var(--top-toolbar-height) !important;
  width: var(--top-toolbar-height) !important;
}
.main-menu-app.v-application .v-main {
  padding:  0px 0px 0px !important;
  height: 100vh;
}
.main-menu-app .content-container:not(.inFrame) {
  background: #f2f3f4;
  max-height: calc(100% - var(--top-toolbar-height));
}

.user-account-panel::before {
  content: "";
  display: block;
  position: absolute;
  right: 12px;
  top: -20px;
  border: 10px solid transparent;
  border-bottom-color: #fff;
}

.user-account-panel  {
  width: 490px;
  border-radius: 4px;
  position: absolute;
  z-index: 5;
  background: #fff;
  border: 1px solid #ccc;
  border-color: rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
  right: 10px;
  top: 54px;
}
.circular-photo {
  height: 96px;
  width: 96px;
  margin-right: 20px;
  overflow: hidden;
  border-radius: 50%;
  display: block;
}
.uap-top-info {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.uap-user-fio {
  font-weight: 500;
  margin: -4px 0 0px 0;
  color: rgba(0, 0, 0, 1);
}
.uap-user-login {
  color: #666;
  text-transform: lowercase;
}
.uap-user-change-pass {
  color: var(--accentColor);
  cursor: pointer;
  margin: 3px 0;
  display: inline-block;
}

.uap-top {
  display: flex;
  font-size: 13px;
  margin: 20px;
  flex-direction: column;
}
.toolbar-user-photo.v-icon {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 7px 0 10px;
  cursor: pointer;
}
.app-main-menu-spacer {
  height: 100%;
}
.toolbar-user-photo.icon {
  color: var(--md-pallete-on-500) !important;
  font-size: var(--top-toolbar-user-photo-size);
}

.toolbar-user-photo.v-image {
  align-items: center;
  margin: 0 7px 0 10px;
  cursor: pointer;
  width: var(--top-toolbar-user-photo-size);
  height: var(--top-toolbar-user-photo-size);
  border-radius: 50%;
}

.uap-serv-buttons .uap-action {
  cursor: pointer;
}
.uap-serv-buttons .uap-action:hover svg {
  fill: var(--accentColor);
}

.lang-switcher-container,
.notifications-container {
  padding: var(--top-toolbar-btn-padding);
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  max-height: var(--top-toolbar-height);
}
.lang-switcher-container::v-deep .v-btn.v-btn--icon.v-size--default,
.notifications-container::v-deep .v-btn.v-btn--icon.v-size--default {
  height: 100%;
  width: 100%;
}
.lang-switcher-container:hover,
.notifications-container:hover {
  background: rgba(255, 255, 255, 0.4);
}

.notifications-container::v-deep .v-badge {
  display: flex;
}

.notifications-container::v-deep .v-badge__badge {
  font-size: 10px;
  height: 16px;
  min-width: 16px;
  padding: 3px 4px;
}

.main-menu-app #home-app-bar {
  position: unset;
}

.hidden-menu {
  width: unset;
}

.uap-user-actions {
	display: flex;
	padding-top: 10px;
	justify-content: space-between;
}

.uap-user-actions .uap-user-actions-button {
  margin: 0 0 0 20px;
}

.uap-user-actions .uap-user-actions-button .uap-u-a-caption {
	line-height: 18px;
	padding: 2px 0;
}

.uap-user-actions .uap-user-actions-button .uap-u-a-title {
  font-size: 12px;
	color: #929292;
}

.uap-user-actions .uap-user-actions-button:first-child {
  margin-left: 0;
}

.uap-user-actions .uap-user-actions-button i {
  display: none;
}

.uap-user-actions .uap-user-actions-button .uap-user-actions-button-dd {
  display: block;
	margin-left: 3px;
	margin-right: -3px;
}

.uap-user-actions .uap-action {
  font-size: 13px;
  margin-bottom: 6px;
}

.uap-user-actions .uap-action::v-deep .v-input__slot:before,
.uap-user-actions .uap-action::v-deep .v-input__slot:after,
.uap-user-actions .uap-action::v-deep input {
  display: none;
}

.uap-user-actions .uap-action::v-deep .v-icon {
  color: var(--accentColor);
  font-size: 15px;
  transform: none;
}

.uap-user-actions .uap-action::v-deep .v-input__append-inner {
  margin: 0px;
  padding: 0px;
}

.uap-user-actions .uap-action::v-deep .v-select__slot:hover {
  text-decoration: underline;
  color: var(--accentColor);
}

.uap-user-actions .uap-action::v-deep .v-input__icon {
  height: 15px;
  width: unset;
  min-width: unset;
}

.selection-text {
  color: var(--accentColor);
  height: 20px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.v-list {
  padding: 0px;
}

.v-list::v-deep .v-list-item {
  padding: 5px 10px 5px 5px;
  min-height: 24px;
  height: 34px;
}

.text-content {
  cursor: pointer;
  color: #666;
  font-size: 13px;
  align-items: center;
  display: flex;
}
.text-content::before {
  content:'';
  width: 24px;
  padding-right: 5px;
}

.v-list::v-deep .theme--light.v-list-item--active:before {
  opacity: 0;
}

.v-list::v-deep .theme--light.v-list-item:hover:before {
  opacity: .04;
}
.v-list .v-list-item.v-list-item--active .text-content::before,
.v-list .v-list-item.active .text-content::before {
  content: "\F012C";
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: 24px;
  padding-right: 5px;
}

</style>